<script>

	import Chat from './Spotlight/Chat.svelte';
	import Question from './Spotlight/Question.svelte';
	import Poll from './Spotlight/Poll.svelte';

	import { spotlight } from './lib/stores.js';

	function handleKeydown(event){
		if (event.key === 'Escape') {
			$spotlight = null;	
		}
	}

</script>

<svelte:window on:keydown={handleKeydown}/>

{#if $spotlight && $spotlight.type == 'chat'}
	<Chat/>
{:else if $spotlight && $spotlight.type == 'qa'}
	<Question/>
{:else if $spotlight && $spotlight.type == 'poll'}
	<Poll/>
{/if}